var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.615 105.837C23.55 105.837 23.49 105.837 23.42 105.832C21.845 105.752 20.3 105.412 18.83 104.817C11.595 101.877 8.10501 93.6115 11.04 86.3815L47.645 22.2515C48.905 19.9715 50.815 18.0615 53.145 16.7715C59.97 12.9915 68.6 15.4765 72.375 22.2965L108.74 85.9365C109.55 87.8415 109.895 89.3915 109.98 90.9715C110.175 94.7515 108.885 98.3765 106.355 101.182C103.825 103.987 100.35 105.642 96.575 105.832L23.975 105.837H23.615Z",
    fill: "#D6E4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6253 50.1041C55.6253 47.6941 57.5903 45.7291 60.0003 45.7291C62.4103 45.7291 64.3753 47.6941 64.3753 50.1041V64.2441C64.3753 66.6591 62.4103 68.6191 60.0003 68.6191C57.5903 68.6191 55.6253 66.6591 55.6253 64.2441V50.1041ZM55.625 81.3495C55.625 78.9245 57.59 76.9495 60 76.9495C62.41 76.9495 64.375 78.8995 64.375 81.2945C64.375 83.7595 62.41 85.7245 60 85.7245C57.59 85.7245 55.625 83.7595 55.625 81.3495Z",
    fill: "#200E32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/Danger.a514e9c64a76d5cf149bdd7443857605.svg";
export { ForwardRef as ReactComponent };